<div class="company-popup-container">
  <!-- Header -->
  <div class="popup-header">
    <div class="popup-header-content">
      <div class="header-left">
        <h3 class="popup-company-name">Company: {{data.company.entity_name}}</h3>
        <h4 class="popup-theme">Theme: {{data.theme}}</h4>
        
        <!-- Dynamic Description -->
        <p *ngIf="!showInventions" class="header-description">
          Below is the innovation activity of {{data.company.entity_name}} in the "{{data.theme}}" theme over the last 10 years. The chart shows the number of inventions published each year, and the table below shows the top keywords from recent inventions.
        </p>
        <p *ngIf="showInventions" class="header-description">
          Below are the 100 most recent inventions (patent families) owned by {{data.company.entity_name}} in the "{{data.theme}}" theme. You can adjust dates to look into earlier inventions or use the quality score filter to look for the most valuable inventions.
        </p>
      </div>
      
      <div class="header-right">
        <!-- Navigation Buttons -->
        <div class="header-navigation">
          <button class="nav-btn" 
                  [ngClass]="{'nav-btn-active': !showInventions, 'nav-btn-inactive': showInventions}"
                  (click)="showActivityView()" 
                  matTooltip="View Innovation Activity">
            <i class="bi bi-graph-up"></i>
            <span>Activity</span>
          </button>
          
          <button class="nav-btn" 
                  [ngClass]="{'nav-btn-active': showInventions, 'nav-btn-inactive': !showInventions}"
                  (click)="showInventionsView()" 
                  matTooltip="View Inventions">
            <i class="bi bi-lightbulb"></i>
            <span>Inventions</span>
          </button>
        </div>
      </div>
      
      <!-- Close Button - Absolutely positioned in top right corner -->
      <button class="popup-close-btn" (click)="closePopup()" matTooltip="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>

  <!-- Content Area -->
  <div class="popup-content">
    <!-- Innovation Activity View (Default) -->
    <div [hidden]="showInventions" class="activity-view">
      <app-innovation-activity
        [isPopup]="true"
        [popupCompanyName]="data.company.entity_name"
        [popupTheme]="data.theme"
        [tabId]="data.tabId + '-activity-' + refreshKey"
        [query]="data.query"
        [entityids]="[data.company.entityid]">
      </app-innovation-activity>
    </div>

    <!-- Inventions View -->
    <div [hidden]="!showInventions" class="inventions-view">
      <app-inventions-view
        [isPopup]="true"
        [popupCompanyName]="data.company.entity_name"
        [popupTheme]="data.theme"
        [tabId]="data.tabId + '-inventions-' + refreshKey"
        [query]="data.query"
        [entityids]="[data.company.entityid]">
      </app-inventions-view>
    </div>
  </div>
</div>
